/**
 * Markdown styling configuration for AI Insights
 */
export const MARKDOWN_STYLES = {
  text: {
    fontSize: 12,
    lineHeight: 20,
    fontWeight: 400,
    marginBottom: 0,
    marginTop: 0,
    color: '#FFFFFF',
    fontFamily: 'Bozon',
  },
  paragraph: {
    marginBottom: 16,
    marginTop: 0,
  },
} as const;

/**
 * Overrides for the beta chat view — slightly larger text, matching mobile's BETA_MARKDOWN_STYLES
 */
export const BETA_MARKDOWN_STYLES = {
  ...MARKDOWN_STYLES,
  text: {
    ...MARKDOWN_STYLES.text,
    fontSize: 14,
    lineHeight: 22,
  },
} as const;
